module.exports = __webpack_public_path__ + "media/img/pages/companies/hospice-general-75bff118e52c80efbec64c7d09e6454d.png";